export default {
  createRouteMapper(routes) {
    let mapper = {};

    function _createRouteMapper(routes, base = '') {
      for (let i = 0; i < routes.length; i++) {
        let route = routes[i];

        let path = route.path;
        if (path === '/' && route.alias != null) {
          path = base + '/' + route.alias;
        } else if (path.indexOf('/') === -1) {
          path = base + '/' + path;
        }
        let children = route.children;
        if (children != null && children.length > 0) {
          _createRouteMapper(children, path);
        }

        let meta = route.meta;
        if (meta == null || meta.exportKey == null) {
          continue;
        }
        let exportKey = meta.exportKey;
        let key = exportKey.external === true ? exportKey.key : exportKey;
        mapper[key] = {
          path: path,
          meta: meta
        };
      }
    }

    _createRouteMapper(routes);

    return mapper;
  },
  compositeSecondaryHeaderConfig(route) {
    let secondaryRoutes = [];
    if (route == null) {
      return secondaryRoutes;
    }

    let base = route.path;
    let children = route.children;
    if (children == null || children.length === 0) {
      return secondaryRoutes;
    }

    for (let i = 0; i < children.length; i++) {
      let child = children[i];
      let meta = child.meta;

      if (meta == null || !meta.secondaryHeader) {
        continue;
      }

      let path = child.path;
      let alias = child.alias;

      if (path === '/') {
        if (alias) {
          path = base + '/' + alias;
        } else {
          path = base;
        }
        alias = base;
      } else if (path.indexOf('/') !== 0) {
        path = base + '/' + path;
      }

      secondaryRoutes.push({
        to: path,
        alias: alias,
        icon: meta.iconName,
        title: meta.name,
        meta: meta
      });
    }

    return secondaryRoutes;
  }
};



// WEBPACK FOOTER //
// ./src/router/utils.js